import { ActivatedRouteSnapshot, CanActivate, NavigationEnd, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationFacade } from '../+state';
import { CompanyConfigFacade } from '@symphony-solo/domain/company-config/src/lib/+state/company-config.facade';
import { combineLatest, Observable, of } from 'rxjs';
import { map, catchError, first } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { CHOOSE_LOCATION_TABS, LOGIN, PAYMENT_SUCCESS } from '@symphony-solo/shared/utils/src';
import { NavController } from '@ionic/angular';
// import { OrderFacade } from '@symphony-solo/domain/order/src/lib/+state/order.facade';

@Injectable()
export class GuestCheckoutGuard implements CanActivate {
  public currentRoute: string;
  private previousUrl: string;
  constructor(
    // private orderFacade: OrderFacade,
    private authenticationFacade: AuthenticationFacade,
    private companyConfigFacade: CompanyConfigFacade,
    private router: Router,
    protected navCtrl: NavController,
    
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Store the previous URL after navigation ends
        this.previousUrl = event.urlAfterRedirects;
      }
    });
  }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    // Delay the check to ensure previousUrl is set
    return new Observable<boolean>((observer) => {
      setTimeout(() => {
        combineLatest([
          this.companyConfigFacade.isAnonymousBrowsing$,
          this.companyConfigFacade.checkoutAsGuestSharedAccountId$,
          this.authenticationFacade.isAuthenticated$,
        ])
        .pipe(
          first(),
          map(([isAnonymous, checkoutAsGuestSharedAccountId, isAuthenticated]) => {
            // Handle if previousUrl is undefined
            if (this.previousUrl && this.previousUrl.includes(PAYMENT_SUCCESS)) {
              if (!isAuthenticated) {
                this.navCtrl.navigateRoot(LOGIN);  // Redirect to login if not authenticated
                observer.next(false);  // Deny navigation
                observer.complete();
                return;  // Exit early
              } else {
                this.navCtrl.navigateRoot(CHOOSE_LOCATION_TABS);  // Redirect to location tabs
                observer.next(false);  // Deny navigation
                observer.complete();
                return;  // Exit early
              }
            }
  
            // Default check if previousUrl is not PAYMENT_SUCCESS
            const guestCheckoutAllowed =
              isAnonymous && checkoutAsGuestSharedAccountId !== null && checkoutAsGuestSharedAccountId.length > 0;
  
            observer.next(guestCheckoutAllowed || isAuthenticated);  // Allow navigation
            observer.complete();  // Complete the observable
          }),
          catchError((error) => {
            console.error('Error:', error);  // Optionally log the error
            observer.next(false);  // Deny navigation on error
            observer.complete();
            return of(false);  // Return an observable in case of error
          })
        ).subscribe();
      }, 0); // Delay the check to ensure previousUrl is populated
    });
  }
  
  
}
